import { Outlet } from 'react-router'
import { SiteFooter } from '../components/footer'

const Page = () => {
  return (
    <div className="flex flex-col min-h-dvh">
      <Outlet />
      <SiteFooter />
    </div>
  )
}

export default Page
